import styled from "styled-components";
import { text } from "../../lib/sharedStyles";

export const Tile = styled.a<{ $zoom: boolean; brand: string; }>`
  display: flex;
  flex-direction: column;
  text-decoration: none;

  &:hover {
    cursor: pointer;
    ${({ $zoom }) => $zoom ? `
      img {
        transform: scale(1.1);
      }
    ` : `
      > div img:nth-of-type(1) {
        opacity: 0;
      }

      > div img:nth-of-type(2) {
        opacity: 1;
      }
    `}
  }

  ${({ brand }) => brand === "jackson" && `
    text-transform: uppercase;
    font-weight: 700;
    font-family: Palanquin Dark, sans-serif;
  `}
`;

export const ImageContainer = styled.div<{ tileType: string; brand: string; }>`
  position: relative;
  overflow: hidden;
  padding: 32px;
  border-radius: 16px;
  margin-bottom: 16px;
  background-color: #F5F5F5;

  img {
    max-width: 100%;
    transition: all 300ms ease;
  }

  ${({ brand }) => brand === "jackson" && `
    border-radius: 0;
    text-transform: uppercase;
  `}

  ${({ tileType }) => tileType === "Artist" && `
    border-radius: 0;
    padding: 0;
  `}
`;

export const HoverImage = styled.img`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ArtistCaption = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: .75rem 1rem 3rem 1rem;
  width: 100%;
  background: linear-gradient(-180deg, rgba(5, 5, 5, .03), #020202);
`;

export const Title = styled.p<{ tileType: string; }>`
  margin: 0 0 8px;
  ${text(500, '16px', '20px', '#1A1B1B')}

  ${({ tileType }) => tileType === "Artist" && `
    margin: 0;
    font-family: Palanquin Dark,sans-serif;
    font-size: 1.25rem !important;
    font-weight: 700;
    letter-spacing: .125rem;
    line-height: 2rem;
    color: #FFFFFF;
    text-transform: uppercase;
    text-align: center;
    z-index: 2;
  `}
`;

export const Description = styled.p<{ tileType: string; }>`
  margin: 0;
  ${text(400, '14px', '22px', '#888')}
  
  ${({ tileType }) => tileType === "Artist" && `
    font-family: Palanquin,sans-serif;
    font-size: .875rem !important;
    font-weight: 300;
    letter-spacing: .27375rem;
    line-height: 1.25rem;
    margin-bottom: 0;
    color: #FFFFFF;
    text-transform: uppercase;
    text-align: center;
    z-index: 2;
  `}
`;